"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDataPoints = function (points) {
    if (!points) {
        return [];
    }
    return points.map(parseDataPoint).filter(function (point) { return point !== undefined; });
};
var parseDataPoint = function (point) {
    var timestamp = exports.validDateOrUndefined(point.timestamp);
    if (!timestamp) {
        return undefined;
    }
    var measure = point.measure;
    if (measure === undefined || measure === null || typeof (measure) !== 'number') {
        return undefined;
    }
    return {
        measure: measure,
        timestamp: timestamp
    };
};
var timezoneOffsetRegex = /[+-]\d\d:?(\d\d)?$/;
// This function will preserve existing timezone offsets on dates, and otherwise
// will use a regex to deconstruct the `dateString` and use a JS local date constructor.
// `dateString` _must_ take the form of a ISO8601 DateTime string in "extended" form
// (with or without tz) in order to be correctly parsed.
// Ex: "2020-01-01T00:00:00" for 12 AM on January 1, 2020
var dateWithTheRightTimezone = function (dateString) {
    var _a, _b;
    if (dateString.endsWith('Z')) {
        return new Date(dateString);
    }
    if (timezoneOffsetRegex.test(dateString)) {
        // There is already a timezone offset.
        return new Date(dateString);
    }
    if (isNaN(new Date(dateString).getTime())) {
        return undefined;
    }
    var _c = dateString.split('T'), date = _c[0], time = _c[1];
    var _d = (_a = date) === null || _a === void 0 ? void 0 : _a.split('-').map(function (x) { return parseInt(x, 10); }), year = _d[0], month = _d[1], day = _d[2];
    var _e = (_b = time) === null || _b === void 0 ? void 0 : _b.split(':').map(function (x) { return parseFloat(x); }), hour = _e[0], minute = _e[1], second = _e[2];
    var _f = second.toString().split('.').map(function (x) { return parseInt(x, 10); }), s = _f[0], ms = _f[1];
    return new Date(year, month - 1, day, hour, minute, s, (ms !== null && ms !== void 0 ? ms : 0));
};
exports.validDateOrUndefined = function (dateString) {
    if (isNullOrUndefined(dateString)) {
        return undefined;
    }
    var result = dateWithTheRightTimezone(dateString);
    if (result === undefined || isNaN(result.getTime())) {
        return undefined;
    }
    return result;
};
var isNullOrUndefined = function (date) { return date === undefined || date === null; };
//# sourceMappingURL=parseDataPoints.js.map